import { TableV2, TableV2Props } from '@anytag/shared-atoms';
import { InstagramUserHashtagListPostsItemPayload, TiktokUserTagListPostsItemPayload } from '@anytag/graphql';
import { useTableMaxHeight } from '@anytag/shared-hooks';

export type TagsTableProps<TData = TiktokUserTagListPostsItemPayload | InstagramUserHashtagListPostsItemPayload> =
  TableV2Props<TData>;

export const TagsTable = <TData,>(props: TagsTableProps<TData>) => {
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();

  return (
    <TableV2
      ref={offsetRef}
      rowHeight="72px"
      maxHeight={defaultTableMaxHeight}
      noTopBorderRadius
      stickyHeader
      {...props}
    />
  );
};
